import { CONSTANT_TEXTS } from '@gp/constants/const';

const SEGMENT_OVERVIEW = '1';
const SEGMENT_FIVE_YEAR_FORECAST = '2';

const SEGMENT_OPT = [
  {
    text: 'Overview',
    value: SEGMENT_OVERVIEW,
  },
  {
    text: '5-Year Forecast',
    value: SEGMENT_FIVE_YEAR_FORECAST,
  },
];

const STUDIO_DATA_TYPE_LANGUAGE_OPT = {
  en: {
    radio_title: 'Overall',
    button_market: "Studio",
    button_region: "Studio Data Type",
    clear_all: "Clear All",
    country_no_data: CONSTANT_TEXTS.EMPTY_TEXT,
    market_title: "Studio",
    region_title: 'Data Type',
    search: "Search",
    search_none: CONSTANT_TEXTS.EMPTY_TEXT,
    select_all: "Select All",
  },
  cn: {
    radio_title: '聚合数据',
    button_market: "工作室",
    button_region: "工作室数据类型",
    clear_all: "清空",
    country_no_data: "无匹配项",
    market_title: "工作室",
    region_title: "数据类型",
    search: "搜索",
    search_none: "无匹配项",
    select_all: "全选",
  },
};

export {
  SEGMENT_OPT,
  SEGMENT_OVERVIEW,
  SEGMENT_FIVE_YEAR_FORECAST,
  STUDIO_DATA_TYPE_LANGUAGE_OPT,
};
